import yup from '@/utils/yup-global'
import { useTranslations } from 'next-intl'

const useValidationMessages = () => {
  const t = useTranslations('validation')

  return {
    required: {
      height: t('required.height'),
      weight: t('required.weight'),
    },
  }
}

export const useSizeGuideSchema = () => {
  const msg = useValidationMessages()

  return yup.object().shape({
    height: yup
      .number()
      .transform((value, originalValue) => {
        // Handle empty string or invalid input
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return undefined
        }
        return isNaN(value) ? undefined : value
      })
      .required(msg.required.height),
    weight: yup
      .number()
      .transform((value, originalValue) => {
        // Handle empty string or invalid input
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
          return undefined
        }
        return isNaN(value) ? undefined : value
      })
      .required(msg.required.weight),
    shape: yup.string().required(),
  })
}
